import React from 'react';
import SignInRoute from './SignInRoute';

const AgentLoginRoute: React.FC = () => {
  return <SignInRoute />;
};

export default AgentLoginRoute;
